/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {AuthModel, UserModel} from '../core/_models'
import {userInfo} from 'os'
import {useIntl} from 'react-intl'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import {getRegisterDates, getGuideVideo} from '../../auth/core/_requests'
import {getAnnouncements} from '../../../pages/announcement/list/core/_requests'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'

const initialValues = {
  userName: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const navigate = useNavigate()
  const intl = useIntl()
  const loginSchema = Yup.object().shape({
    userName: Yup.string()
      .min(3, useIntl().formatMessage({id: 'Minimum_3_symbols'}))
      .max(50, useIntl().formatMessage({id: 'Maksimum_50_symbols'}))
      .matches(
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
        useIntl().formatMessage({id: 'Email_must_be_lowercase'})
      )
      .required(useIntl().formatMessage({id: 'Email_is_required'})),
    password: Yup.string()
      .min(3, useIntl().formatMessage({id: 'Minimum_3_symbols'}))
      .max(50, useIntl().formatMessage({id: 'Maksimum_50_symbols'}))
      .required(useIntl().formatMessage({id: 'Password_is_required'})),
  })
  const [loading, setLoading] = useState(false)
  const [announcements, setAnnouncements] = useState([])
  const [registerActive, setRegisterActive] = useState(true)
  const [guideVideoLink, setGuideVideoLink] = useState(undefined)
  const {saveAuth, setCurrentUser} = useAuth()
  const lang = useLang()
  const AuthError = useIntl().formatMessage({id: 'AUTH.VALIDATION.INVALID_LOGIN'})

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,

    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data} = await login(values.userName, values.password)

        if (data?.status === 'Success') {
          // Başarılı durum: Yönlendirme
          navigate('/auth/email-verification', {
            state: {
              userName: values.userName,
            },
          })
        } else {
          throw new Error(data?.message || 'Bilinmeyen bir hata oluştu.')
        }

        //saveAuth(auth)
        //const { data: user } = await getUserByToken()

        //setCurrentUser(user)
      } catch (error: any) {
        //console.error(error)
        //saveAuth(undefined)
        // setStatus('The login detail is incorrect')
        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: error.response?.data?.message || error.message || 'Bir hata oluştu.',
        })
        setStatus(AuthError)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    // getRegisterDates().then((a: any) => {
    //   if (a.data?.data?.length === 0) {
    //     setRegisterActive(false)
    //   }
    // })

    getRegisterDates().then((a: any) => {
      if (a.data === false) {
        setRegisterActive(false)
      }
    })
    getAnnouncements().then((a: any) => {
      const activeAnnouncements = a.data?.data?.filter((k: any) => k.isActiveLoginPage) || []
      setAnnouncements(activeAnnouncements)
    })

    getGuideVideo().then((res: any) => {
      setGuideVideoLink(res?.data?.linkPath)
    })
  }, [])

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>{useIntl().formatMessage({id: 'Login'})}</h1>
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='p-3 rounded'>
          <div className='text-light text-center'></div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {useIntl().formatMessage({id: 'Email'})}
        </label>
        <input
          placeholder={useIntl().formatMessage({id: 'Email'})}
          {...formik.getFieldProps('userName')}
          className={clsx('form-control form-control-lg form-control-solid')}
          type='text'
          name='userName'
          autoComplete='off'
        />
        {formik.touched.userName && formik.errors.userName && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.userName}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>
              {useIntl().formatMessage({id: 'Password'})}
            </label>
            {/* end::Label */}
          </div>
        </div>
        <input
          placeholder={useIntl().formatMessage({id: 'Password'})}
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
        <div className='mt-5 d-flex flex-column gap-2'>
          <Link to='/auth/forgot-password' className='link-primary fs-6 mb-0 '>
            {intl.formatMessage({id: 'Forgot Password'})}?
          </Link>
          <a
            href={guideVideoLink ? guideVideoLink : '#'}
            className='link-primary fs-6 mb-0'
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage({id: 'YÖS_Kilavuzu_Video'})}
          </a>
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-dark w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>{intl.formatMessage({id: 'Login'})}</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'Please_wait'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        {registerActive && (
          <a
            href='/auth/registration'
            className='btn btn-flex flex-center btn-light btn-lg w-100 mb-5'
          >
            {intl.formatMessage({id: 'Register'})}
          </a>
        )}
        {/* 
        {announcements.map((a: any) => {
          return lang === 'tr' ? (
            <div className='alert alert-primary mt-5'>{a.text}</div>
          ) : (
            <div className='alert alert-primary mt-5'>{a.textEn}</div>
          )
        })} */}
        {announcements.map((a: any, index: number) => {
          const text = lang === 'tr' ? a.text : a.textEn

          return (
            <div
              key={index}
              className='alert alert-primary mt-5'
              dangerouslySetInnerHTML={{__html: text}}
            />
          )
        })}
        <div className='d-flex flex-center flex-column-auto p-5'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <span className='text-muted px-2 pt-7'>
              <a
                href='http://www.unipa.com.tr'
                target='_blank'
                rel='noreferrer'
                className='text-muted text-hover-dark px-2'
              >
                Unipa
              </a>
              {intl.formatMessage({id: 'Developed_by'})}
              {/* Tarafından Geliştirilmiştir. */}
            </span>
          </div>
        </div>
      </div>
      {/* end::Action */}
    </form>
  )
}
